module.exports = __webpack_public_path__ + "static/media/campaignResult-default.6b430c1e.png";